import { render, staticRenderFns } from "./agent_session_inbox_tab.vue?vue&type=template&id=55da0a73"
import script from "./agent_session_inbox_tab.vue?vue&type=script&lang=js"
export * from "./agent_session_inbox_tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports